import PropTypes from 'prop-types';

export const StorePropType = PropTypes.shape({
  storeGuid: PropTypes.string,
  marketplaceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  isActive: PropTypes.bool,
});

/**
 * @typedef {object} StorePropTypes
 * @property {string} storeGuid
 * @property {string|number} marketplaceId
 * @property {string} name
 * @property {string} isActive
 */
